export const en = {
    adaptive: 'Adaptive',
    all: 'All',
    'banner-sizes': 'Banner sizes',
    categories: 'Categories',
    formats: 'Formats',
    operators: 'Operators',
    'predictor-detailed-less': '< {sum}',
    'predictor-error': 'The forecast is temporarily unavailable',
    'predictor-sum-from': 'of {sum}',
    'predictor-sum-less': 'of < {sum}',
    regions: 'Regions',
    screens: 'Screens',
    zones: 'Zones'
};
